import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect, Form } from 'omni-common-ui';
import HomeworkType from 'data/Homework/Types';

class HomeworkTypeSelect extends PureComponent {

  constructor(props) {
    super(props);
    this._onSelect = this._onSelect.bind(this);
  }

  componentWillMount() {
    this.setState({ val: this.props.value });
  }

  componentDidMount() {
    this.props.fetchTypesIfNeeded(this.props.courseTypeLevelId);
  }

  _onSelect(val) {
    this.setState({
      val,
    });
    this.props.onSelect(val);
  }

  render() {
    const { homeworkContentTypes, getConsumedTypes, value } = this.props;
    if (! homeworkContentTypes.isEmpty()) {
      const consumedTypes = getConsumedTypes();
      const options = homeworkContentTypes.toArray()
        .filter(({ id }) =>
        id === value || ! consumedTypes.contains(id))
        .map((type) => ({
          label: type.name,
          value: type.id,
        }));
      return <Form.Select options={options}
          className={styles.HomeworkTypeSelect}
          name="homeworkType"
          value={this.state.val}
          setValue={this._onSelect}
          clearable={false}
          searchable={false} />;
    }
    return null;
  }

}

HomeworkTypeSelect.propTypes = {
  courseTypeLevelId: PropTypes.string.isRequired,
  value: PropTypes.string,
  homeworkContentTypes: PropTypes.instanceOf(Map).isRequired,
  onSelect: PropTypes.func,
  getConsumedTypes: PropTypes.func,
  fetchTypesIfNeeded: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(HomeworkType.actions, dispatch);
}

function mapStateToProps(state, { courseTypeLevelId }) {
  return {
    homeworkContentTypes:
      HomeworkType.accessors.getTypesByCourseTypeLevelId(state, courseTypeLevelId),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeworkTypeSelect);



// WEBPACK FOOTER //
// ./components/HomeworkTypeSelect/index.jsx